// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"numbers-7-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16.5 6V5H8.5M16.5 6L11 19H10.997L16.5 6Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Numbers71Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'numbers-7-1',
    ref,
    icon: element,
  },
));

Numbers71Icon.displayName = 'Numbers71Icon';

export default Numbers71Icon;
